const mix = (color1: string, color2: string, weight: number = 0.5): string => {
    const d2h = (d: number): string => d.toString(16); // convert a decimal value to hex
    const h2d = (h: string): number => parseInt(h, 16); // convert a hex value to decimal

    let color = '#';

    for (let i = 0; i <= 5; i += 2) { // loop through each of the 3 hex pairs—red, green, and blue
        const v1 = h2d(color1.substr(i, 2)); // extract the current pairs
        const v2 = h2d(color2.substr(i, 2));

        // combine the current pairs from each source color, according to the specified weight
        let val = d2h(Math.floor(v2 + (v1 - v2) * weight));

        while (val.length < 2) {
            val = '0' + val;
        } // prepend a '0' if val results in a single digit

        color += val; // concatenate val to our new color string
    }

    return color;
};

export const stakeFactorColor = (stakeFactor: number): string | undefined => {
    if (stakeFactor <= 0.25) {
        return '#db0000';
    } else if (stakeFactor > 0.25 && stakeFactor <= 0.74) {
        return '#ff6d01';
    } else if (stakeFactor > 0.74 && stakeFactor < 1) {
        return '#ffa801';
    } else if (stakeFactor === 1) {
        return '#ccc';
    } else if (stakeFactor > 1) {
        return mix('00cc4b', 'cccccc', Math.min(stakeFactor / 10, 1));
    }
};
